
import { configureStore, createSlice } from '@reduxjs/toolkit';
import timeTrackingSlice from './ReduxTimerSlice.jsx';
import userContext from './UserContext.js'

const counterSlice = createSlice({
  name: 'AppReduxContext',
  initialState: { 
    openChatModal: false,
    taskModal: {
      open: false,
      taskData: {},
      dealObj: {},
      taskAction: '',
    },
    FolderPickerSelecetdPath:[],
    SelectedFiles:{},
    RefreshData:null,
    InputFieldValidation:[],
    ModuleTab:null,
    AllModuleUsers:{},
    moduleContacts:{},
    AllModule:[],
    AllDeals: [],
    CreateDealData: {},
    EditDealData: {},
    NycApiData: {},
    getNotificationFlag: false,
    refreshTimeclock: false,
    isDeleteEnable:true,
    AllNotificationsForChat: [],
    timer:0,
    OnClickEdge:null,
    // AllTasks:[],
    CustomeRefreshButton:false,
    ClientLayoutChanged: false,
    SaveClickedForClient: false,
    isReminderPopupOpen:{status:false,email:null},
    AllTaskTimeTracking:[],
    TaskFlowEditCount:0,
    EnableFlow:true,
    billingTerms: [],
    reminderData:{},
    cacheReminderData:[],
    DealStatusOptions: [],
    refershModule:{module:"",data:""},
    taskActiveKey:{tab : "tasks", view : ""},
    hrActiveKey:{tab : "timeSheet", view : ""},
    addTimeSheetClicked:{module: "", button: ""},
    ActionsOfTimeClock: "",
    SelectedIdsForTimeClock: {},
    forwardObject: {module:null,data:null,state:""},
  },
  reducers: {
    FolderPickerSelecetdPath: (state,action) => {
      state.FolderPickerSelecetdPath = action.payload;
    },
    SelectedFiles: (state,action) => {
      state.SelectedFiles = action.payload;
    },
    RefreshData: (state,action) => {
      state.RefreshData = action.payload;
    },
    // setAllTasks: (state,action) => {
    //   state.AllTasks = action.payload;
    // },
    PushInputFieldValidation: (state,action) => {
      if(!state.InputFieldValidation.includes(action.payload)){
        state.InputFieldValidation.push(action.payload);
      }
      // console.log("Add---", {...state.InputFieldValidation});
      
    },
    RemoveInputFieldValidation: (state,action) => {
      state.InputFieldValidation = state.InputFieldValidation.filter(k=>k!=action.payload);
      // console.log("Remove---", {...state.InputFieldValidation});
    },
    ResetInputFieldValidation: (state,action) => {
      state.InputFieldValidation = [];
    },
    SetModuleTab: (state,action) => {
      state.ModuleTab = action.payload;
    },
    setAllModuleUsers:(state,action)=>{
      state.AllModuleUsers = action.payload;
    },
    setAllModule:(state,action)=>{
      state.AllModule = action.payload;
    },
    setModuleContacts:(state,action)=>{
      state.moduleContacts = action.payload;
    },
    setAllDeals: (state, action) => {
      state.AllDeals = action.payload;
    },
    setCreateDealData: (state, action) => {
      state.CreateDealData = action.payload;
    },
    setEditDealData: (state, action) => {
      state.EditDealData = action.payload;
    },
    setNycApiData: (state, action) => {
      state.NycApiData = action.payload;
    },
    setNotificationFlag: (state, action) => {
      state.getNotificationFlag = action.payload;
    },
    setrefreshTimeClock: (state, action) => {
      state.refreshTimeclock = action.payload;
    },
    setIsDeleteEnable: (state, action) => {
      state.isDeleteEnable = action.payload;
    },
    setAllNotificationsForChat: (state, action) => {
      state.AllNotificationsForChat = action.payload;
    },
    addTimer: (state, action) => {
      state.timer=state.timer+action.payload;
    },
    setOnClickEdge: (state, action) => {
      state.OnClickEdge = action.payload;
    },
    setCustomeRefreshButton: (state, action) => {
      state.CustomeRefreshButton = action.payload;
    },
    setClientLayoutChanged: (state, action) => {
      state.ClientLayoutChanged = action.payload;
    },
    setSaveClickedForClient: (state, action) => {
      state.SaveClickedForClient = action.payload;
    },
    setIsReminderPopupOpened: (state, action) => {
      state.isReminderPopupOpen = action.payload;
    },
    setAllTaskTimeTracking: (state, action) => {
      state.AllTaskTimeTracking = action.payload;
    },
    setTaskFlowEditCount: (state, action) => {
      state.TaskFlowEditCount = action.payload;
    },
    setEnableFlow: (state, action) => {
      state.EnableFlow = action.payload;
    },
    setBillingTerms: (state, action) => {
      state.billingTerms = action.payload;
    },
    setReminderData: (state, action) => {
      state.reminderData = action.payload;
    },
    setCacheReminderData: (state, action) => {
      state.cacheReminderData = action.payload;
    },
    setDealStatusOptions: (state, action) => {
      state.DealStatusOptions = action.payload;
    },
    setRefershModule: (state, action) => {
      state.refershModule = action.payload;
    },
    setTaskActiveKey: (state, action) => {
      state.taskActiveKey = action.payload;
    },
    setOpenChatModal: (state, action) => {
      state.openChatModal = action.payload;
    },
    openTaskModal: (state, action) => {
      state.taskModal.open = true;
      state.taskModal.taskData = action.payload.taskData;
      state.taskModal.dealObj = action.payload.dealObj;
      state.taskModal.taskAction = action.payload.taskAction || 'Edit';
    },
    closeTaskModal: (state) => {
      state.taskModal = {
        open: false,
        taskData: {},
        dealObj: {},
        taskAction: '',
      };
    },
    setHrActiveKey: (state, action) => {
      state.hrActiveKey = action.payload;
    },
    setAddTimeSheetClicked: (state, action) => {
      state.addTimeSheetClicked = action.payload;
    },
    setActionsOfTimeClock: (state, action) => {
      state.ActionsOfTimeClock = action.payload;
    },
    setSelectedIdsForTimeClock: (state, action) => {
      state.SelectedIdsForTimeClock = action.payload;
    },
    setForwardObject: (state, action) => {
      state.forwardObject = action.payload;
    },
  },
});

export const { FolderPickerSelecetdPath, setAllDeals, setNotificationFlag, setIsDeleteEnable, addTimer,
  setOnClickEdge, setCustomeRefreshButton, setClientLayoutChanged, setSaveClickedForClient, setIsReminderPopupOpened,
  setAllTaskTimeTracking, setrefreshTimeClock, setAllNotificationsForChat, setTaskFlowEditCount, setEnableFlow,
  setBillingTerms, setReminderData, setCacheReminderData, setDealStatusOptions, setRefershModule,
  setTaskActiveKey, openTaskModal, setOpenChatModal, closeTaskModal, setHrActiveKey,
  setEditDealData, setNycApiData, setCreateDealData, setModuleContacts, setAllModuleUsers,
  setAllModule, SetModuleTab, SelectedFiles, RefreshData, PushInputFieldValidation,
  RemoveInputFieldValidation, ResetInputFieldValidation, setAddTimeSheetClicked, setActionsOfTimeClock, 
  setSelectedIdsForTimeClock, setForwardObject,
} = counterSlice.actions;

const storeRedux = configureStore({
  reducer: {
    AppReduxContext: counterSlice.reducer, 
    TimeTrackingSlice: timeTrackingSlice,
    UserContext: userContext,
  },
});

export default storeRedux;
